import clsx from 'clsx';
import React from 'react';

const InputWrapper = ({ className, children }) => {
  return <div className={clsx(className, 'mb-4')}>{children}</div>;
};

export default InputWrapper;
